// material-ui
import { Box, useMediaQuery } from '@mui/material';

// project import
import Profile from './Profile';
import MobileSection from './MobileSection';
// import Toggle from '../../../../components/toggle-switch/ToggleSwitch'
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import SwitchButton from '../../../../bmr/components/common/SwitchButton';

// ==============================|| HEADER - CONTENT ||============================== //
function transformPath(path) {
  path = path.replace(/^\//, '');
  const parts = path.split('/');

  const transformedParts = parts.map(part => {
    if (part.includes('-')) {
      return part.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    } else {
      return part.charAt(0).toUpperCase() + part.slice(1);
    }
  });

  return transformedParts?.[0] || "";
  // return transformedParts.join('');
}
/* @info Labels on the Patient screen are displayed dynamically based on the phase type. */
function getHeaderLabel(location) {
  const { pathname } = location;
  const isPatientPage = pathname === '/patient';

  if (isPatientPage) {
    return 'Patient/Subject';
  }

  return transformPath(pathname?.includes("products/") ? "/product" : pathname);
}
const HeaderContent = ({ handleSetOpenLogoutSnackbarTrue }) => {
  const location = useLocation();
  const navigate = useNavigate()
  // const [alignment, setAlignment] = useState("CDM")
  const [portalSelected, setPortalSelected] = useState('cdm');
  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const portal_access = useSelector((state) => state.loginData).portal_access;
  const portalOptions = [
    { value: 'cdm', label: 'CDM' },
    { value: 'bmr', label: 'VtoV' },
  ];
  const handleToggleChange = (value) => {
    if (value) {
      setPortalSelected
      navigate("/bmr/dashboard")
    }
  }
  return (
    <>
      {/* {!matchesXs && ""} */}
      {matchesXs && <Box sx={{ width: "100%", ml: { xs: 0, lg: -2 } }} />}
      <span className="font-bold ml-1 xs:ml-3 text-sm md:text-base w-[110px] 1sm:!w-full break-all truncate overflow-hidden whitespace-nowrap">
           {getHeaderLabel(location)}
      </span>

      <div className="flex md:justify-end md:w-screen mr-2 ">
        {/* {portal_access == 3 && <Toggle
          leftText={"CDM"}
          rightText={"VtoV"}
          disabled={true}
          setAlignment={setAlignment}
          alignment={alignment}
        />} */}
        {portal_access == 3 && <SwitchButton
          options={portalOptions}
          value={portalSelected}
          onChange={handleToggleChange}
        />}
      </div>
      {portal_access == 3 && <p className="sm:p-2 md:pl-6 md:pr-4 text-lg text-gray-400">|</p>}
      {!matchesXs && (
        <Profile
          handleSetOpenLogoutSnackbarTrue={handleSetOpenLogoutSnackbarTrue}
        />
      )}
      {matchesXs && (
        <MobileSection
          handleSetOpenLogoutSnackbarTrue={handleSetOpenLogoutSnackbarTrue}
        />
      )}
    </>
  );
};

export default HeaderContent;
